import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isApiSuccess, resolveStoreQrHandle } from "../../services/api"; // adjust path

// GET /store-pay/resolve/{handle}: scanned QR handle -> store id
export const resolveStoreQr = createAsyncThunk("storeQr/resolve", async (handle, { rejectWithValue }) => {
    try {
        const res = await resolveStoreQrHandle(handle);
        if (!isApiSuccess(res) || !res?.data?.store_id) throw res;
        return res.data; // { store_id, store_name, qr_handle }
    } catch (err) {
        return rejectWithValue(err?.message || "Store not found");
    }
});

const initialState = { storeId: null, storeName: "", handle: "", loading: true, error: "" };

const storeQrSlice = createSlice({
    name: "storeQr",
    initialState,
    reducers: {
        clearStoreQr: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(resolveStoreQr.pending, (state) => {
                state.loading = true;
                state.error = "";
                state.storeId = null;
            })
            .addCase(resolveStoreQr.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.storeId = Number(payload.store_id);
                state.storeName = payload.store_name || "";
                state.handle = payload.qr_handle || "";
            })
            .addCase(resolveStoreQr.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload || "Store not found";
            });
    },
});

export const { clearStoreQr } = storeQrSlice.actions;
export default storeQrSlice.reducer;